// Native confirmation is opt-in via the isNativeRedirect URL param, plus existing
// LaunchDarkly / origin / dealer-mode gates. When this returns false, CFUI shows
// the legacy confirmation page instead of posting back to the native app.
export const shouldNotifyNativeApp = (state) => {
    const isOcapp = (state.prefillReducer?.ultimateOrigin || '').indexOf('OCAPP') > -1;
    const deploymentMode = state.prefillReducer?.dealerSummaryObject?.dealershipSummary?.deploymentMode;
    return (
        state.prefillReducer?.isNativeRedirect === true &&
        !!state.appointmentReducer?.enableNativeAppConfirmation &&
        !!state.appointmentReducer?.nativeConfirmationBacFilter &&
        isOcapp &&
        deploymentMode !== 'REQUEST_FORM'
    );
};
